<a
  #linkEl
  [href]="$safeNavigationMigration(field.templateOptions?.url)"
  target="_blank"
  >{{ $safeNavigationMigration(field.templateOptions?.txt) | translate }}</a
>
